<script lang="ts">
  import QueueEntryForm from "$shared/components/parkito/queue/QueueApplicantForm.svelte";
  import {
    ErrorCloud,
    LoadingIndicator,
    Separator,
    Toast,
  } from "$components";
  import { onMount } from "svelte";
  import { fade } from "svelte/transition";
  import type { MyPagesStart, Queue, Tag } from "$apis/parkito";
  import { withApi } from "$shared/lib/api-parkito";
  import SvelteMarkdown from "svelte-markdown";

  // Value from subrouter Root.svelte
  //export let myPagesData: SvelteStore<MyPagesStart> | undefined;
  export let params: { siteId: string; queueId: string };
  export let myPagesData: SvelteStore<MyPagesStart> | undefined;
  let tags: Tag[] = [];
  let queue: Queue | undefined = undefined;
  let submitted: boolean = false;

  const getQueue = async (queueId: string) => {
    const res = await withApi((api) => {
      return api.queueGet(queueId);
    });

    if (res.isOk()) {
      queue = res.value;
    } else {
      Toast.error("Kunde inte hämta kö");
    }
  };

  const getQueueTags = async (queueId: string) => {
    const res = await withApi((api) => {
      return api.queueGetAvailability(queueId, {});
    });

    if (res.isOk()) {
      tags = res.value.tags.map((qt) => qt.tag);
    } else {
      Toast.error("Kunde inte hämta taggar");
    }
  };

  onMount(async () => {
    if (import.meta.env.DEV) {
      console.log("mounting QueueApplicant. Queueid." + params.queueId);
    }
    getQueue(params.queueId);
    getQueueTags(params.queueId);
  });
</script>

<div in:fade={{ duration: 150 }}>
  <div class="px-[24px] py-[24px] max-mobile:px-[8px] max-mobile:py-[8px]">
    <h2 class="text-[#181818] text-[17px] -mt-[30px] inline relative">
      {queue?.name ?? "Ny intresseanmälan"}
    </h2>
  </div>

  <Separator customClass="max-mobile:hidden" />

  <div class="p-[24px]">
    {#if !myPagesData && $myPagesData !== undefined}
      <LoadingIndicator />
    {:else if submitted === false}
      {#if queue}
        <img
          src="./graphics/queue.svg"
          alt="digital-keys"
          class="mx-auto pt-[8px] pb-[32px]"
        />
        <div>
          <SvelteMarkdown
            source={queue.presentation}
            options={{ mangle: false }}
          />
        </div>

        <Separator customClass="max-mobile:hidden my-[24px]" />
      {/if}

      {#if tags.length > 0}
        <QueueEntryForm
          siteTags={tags}
          queueId={params.queueId}
          selectableDebtors={$myPagesData?.debtors}
          bind:submitted
        />
      {:else}
        <ErrorCloud
          altMessage="no-tags-found"
          title="Inga taggar hittades"
          text="Anläggningen har inga taggar vilket krävs för att kunna skapa en intresseanmälan. Skapa taggar under anläggningens tagg-vy."
        />
      {/if}
    {:else}
      <h2>
        <img
          src="/icons/checkmark-blue-green.svg"
          alt="OK"
          class="inline w-[18px] mr-[6px] mb-[3px]"
        />Tack för din intresseanmälan!
      </h2>
      <p class="mt-[24px]">
        Vi kommer att kontakta dig så snart vi har en ledig plats att erbjuda.
      </p>
      <p class="mt-[16px]">
        Vänliga hälsningar,<br />
        Parkando
      </p>
      <p class="mt-[24px] underline">
        <a href="#/">Gå till startsidan för Mina sidor</a>
      </p>
    {/if}
  </div>
</div>
